import type { Organization, OrganizationSearchCommand } from '../entity/ProjectTypes';
import type { ProjectRepository } from '../repository/ProjectRepository';
import { assertArray, normalizeLimit, normalizeOffset } from './_utils';

export class SearchOrganizationsUseCase {
  constructor(private readonly repository: ProjectRepository) {}

  async execute(command: OrganizationSearchCommand): Promise<{ meta?: object; data?: Organization[] }> {
    assertArray(command.params, 'params');

    // API 문서 상 limit/offset은 optional이므로 기본값은 UseCase에서 계산
    const limit = normalizeLimit(command.limit, 10, 1000);
    const offset = normalizeOffset(command.offset, 0);

    return this.repository.searchOrganizations({
      ...command,
      limit,
      offset,
    });
  }
}


